<template>
  <div id="map_container" class="map_container">
    <div v-if="loading" class="loading-spinner">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import {initMap} from "@/utils/mapUtil/funcs";
import {mapGetters} from "vuex";
import {message as Message} from "@/js/utils/message";
import L from "leaflet";
import 'leaflet-markers-canvas'
import {machineTrajectoryData} from "@/api/njjg";
import {addMapMarkers, handleZoomForBoundary} from "@/utils/mapUtil/leafletFun";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'

export default {
  name: "LeafletMap",
  computed: {
    ...mapGetters(["topSelectAreacode", 'topSelectAreaname', 'identityObj']),
  },
  data() {
    return {
      map: null, // 地图对象
      areaCode: '', // 省份代码
      trajectoryData: [], // 轨迹数据
      loading: false, // 加载中
      trajectoryLayer: null, // 轨迹图层
      markersCanvas: null, // 清除canvas图层
    }
  },
  mounted() {
    this.areaCode = this.identityObj.areaCode;
    console.log(this.identityObj, 'this.identityObj');
    this.map = initMap("map_container")
    // 添加地图边界
    addMapMarkers(this.map, this.identityObj.areaFullName, `county='${this.identityObj.areaName}'`, this.identityObj.centerPoint)
    // 监听地图缩放事件 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    this.map.on('zoomend', this.handleZoomEnd);
    // this.getTrajectoryData({
    //   areaCode: this.areaCode,
    //   startTime: '2023-07-01',
    //   endTime: '2023-07-31',
    // });
  },
  methods: {
    // 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
    handleZoomEnd() {
      const zoomRanges = [
        {layerType: 'service', range: [12, 20], ...layerServiceURL['china_township']},
      ];
      handleZoomForBoundary(this.map, this, zoomRanges)
    },

    // 获取轨迹数据
    async getTrajectoryData(params) {
      this.loading = true;
      let res = await machineTrajectoryData(params)
      if (res.code === 0 && res.data && res.data.length > 0) {
        this.trajectoryData = res.data;
        // 绘制轨迹线
        this.drawTrajectoryLine(this.trajectoryData)
        this.loading = false;
      } else {
        this.loading = false;
        this.clearTrajectoryLine()
        this.$message({
          type: 'info', // success error warning
          message: '暂未查询到数据',
          duration: 2000,
        })
      }
    },

    // 绘制轨迹线
    drawTrajectoryLine(data) {
      // 清除轨迹线轨迹点图层
      this.clearTrajectoryLine()
      // 实时点数据
      const realTimePoints = []
      // 轨迹线图层
      this.trajectoryLayer = L.featureGroup().addTo(this.map)
      // 创建轨迹点canvas图层
      if (!this.markersCanvas) {
        this.markersCanvas = new L.MarkersCanvas({autoRedraw: false}).addTo(this.map);
      } else {
        this.markersCanvas.clear();
      }
      // 绘制轨迹线
      const allTraces = data.flatMap(item => {
        if (item.traces && item.traces?.length > 0) {
          // 轨迹点信息
          const content = `
            <div class="vehicle-info">
              <div>农机类型：${item.machineType}</div>
              <div>车牌号：${item.carNumber}</div>
              <div>驾驶员：${item.driverName}</div>
              <div>本次作业时长：${item.workTime}</div>
              <div>服务对象：${item.companyName}</div>
            </div>
          `;
          item.traces.forEach(point => {
            console.log(point, 'point')
            let [lat,lng]=point[point.length - 1]
            let [wgs84lng,wgs84lat]=gcj02towgs84(lng, lat)
            realTimePoints.push(
              L.marker([wgs84lat,wgs84lng], {
                icon: L.icon({
                  iconUrl: 'imgs/tractor.png', // 多图标支持
                  iconSize: [30, 25],
                  iconAnchor: [30, 25]
                })
              }).bindPopup(content)
            )
            // point.forEach(coord => {
            //   realTimePoints.push(
            //     L.marker(coord, {
            //       icon: L.icon({
            //         iconUrl: 'imgs/tractor.png', // 多图标支持
            //         iconSize: [30, 25],
            //         iconAnchor: [30, 25]
            //       })
            //     }).bindPopup(content)
            //   )
            // });
          })
          // 绘制轨迹线
          L.polyline(item.traces, {
            color: '#00BFFF',
            weight: 2,
            opacity: 0.8
          }).addTo(this.trajectoryLayer);
        }
        return item.traces
      });
      // 添加轨迹点
      this.markersCanvas.addMarkers(realTimePoints);

      // 获取所有轨迹的边界
      if (allTraces.length > 0) {
        const bounds = L.latLngBounds(allTraces);
        this.map.fitBounds(bounds);
      }
    },

    // 清除轨迹线
    clearTrajectoryLine() {
      if (this.trajectoryLayer) {
        this.map.removeLayer(this.trajectoryLayer);
        this.trajectoryLayer = null;
      }
      if (this.markersCanvas) {
        this.map.removeLayer(this.markersCanvas);
        this.markersCanvas.clear()
        this.markersCanvas = null;
      }
      this.realTimePoints = [];
    },
  }
}
</script>

<style lang="less" scoped>
.map_container {
  width: 100%;
  height: 100%;
  background: rgba(6, 30, 93, 0.5);
  border-radius: 10px;
  position: relative;
  .loading-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8); /* 背景半透明 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .loader {
    border: 4px solid rgba(0, 0, 0, 0.1); /* 边框颜色 */
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f; /* 转圈颜色 */
    animation: spin 1s infinite linear;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
